var AddSectionCommentMixin, DocumentSectionsV2Actions, mediator;

mediator = require('mediator');

DocumentSectionsV2Actions = require('actions/document_sections_v2_actions');

AddSectionCommentMixin = {
  handleAddComment: function(type) {
    return (function(_this) {
      return function() {
        var chapterId, mdaTopicId, section, _ref;
        _ref = _this.props, section = _ref.section, chapterId = _ref.chapterId, mdaTopicId = _ref.mdaTopicId;
        return DocumentSectionsV2Actions.addSectionComment({
          section: section,
          chapterId: chapterId,
          mdaTopicId: mdaTopicId,
          type: type
        });
      };
    })(this);
  }
};

module.exports = AddSectionCommentMixin;
